mutation updatePositionsWorker($version: String!) {
    updatePositionsWorker(version: $version)
}
